export default {
  methods: {
    // 删除SPU
    handlerefreshShow() {
      this.$confirm((<div class="jsx-content">
        在B2C创建关联关系后，预计在一个小时后会自动刷新数据。
        <span style="color: #E63946; margin-top: 5px;">
          为防止恶意刷新，所以限制手动刷新时间为5分钟
        </span>
      </div>), '温馨提示')
      .then(_=>{
        this.$message('确认按钮')
      })
      .catch(_=>{
        this.$message('取消按钮')
      })
    }
  }
}